import { colors, Pill, Text, Tooltip } from "@vericus/cadmus-ui";

import { formatDistanceStrict } from "date-fns";

interface ExtensionPillProps {
  originalDueDate: string;
  extendedDueDate: string;
}

export function ExtensionPill(props: ExtensionPillProps) {
  const { originalDueDate, extendedDueDate } = props;
  const extension = formatDistanceStrict(
    new Date(originalDueDate),
    new Date(extendedDueDate)
  );
  return (
    <Tooltip
      content={
        <Text kind="bodySm">
          You have a <strong>{extension}</strong> extension.
        </Text>
      }
    >
      <Pill color={colors.white200}>Extension</Pill>
    </Tooltip>
  );
}
